module.exports = __webpack_public_path__ + "img/Etsy.984f9d9c.jpg";